import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { GROUP, ROOT, VENUE } from '../constants/URL.const';
import { useAuthenticationContext } from '../yoello-lib/modules/auth/AuthenticationContext';
import useGenerateNavPath from './useGenerateNavPath';

/**Hook for navigating back to the venue if someone logs out */
export function useNavigateLoggedUser() {
    const { isAuthenticated } = useAuthenticationContext();
    const Venue = useSelector((state: any) => state.Venue);
    const isGroupVenue = useSelector((state: any) => state.IsGroupVenue);
    const { generateNavPath } = useGenerateNavPath();
    const specificMenuId = useSelector((state: any) => state.specificMenuId);
    const history = useHistory();
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    let redirectUrl = params.get('returnPath') ? decodeURI(params.get('returnPath')) : null;

    if (!redirectUrl) {
        if (isGroupVenue) {
            redirectUrl = generateNavPath(GROUP);
        } else {
            if (!Venue || Object.keys(Venue).length === 0) {
                redirectUrl = ROOT;
            } else {
                redirectUrl = generateNavPath(VENUE, Boolean(specificMenuId) && { menu_id: specificMenuId });
            }
        }
    }

    useEffect(() => {
        if (redirectUrl) {
            history.push(redirectUrl, {
                from: history.location.pathname,
                to: redirectUrl,
            });
        }
        //eslint-disable-next-line
    }, [isAuthenticated]);
}
